import React, { useCallback, useState } from "react";
import {
  FacebookLoginButton,
  GoogleLoginButton,
  MicrosoftLoginButton,
} from "react-social-login-buttons";
import { LoginSocialGoogle, LoginSocialFacebook, LoginSocialMicrosoft } from "reactjs-social-login";
import FullPageLoader from "../../Loading/FullPageLoader";
import apiClient from "../../../services/apiClient";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUserDetails } from "../../../features/user/UserSlice";

const SocialLogin = ({ handleSocialLoginResponse }) => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onLoginStart = useCallback(() => {
    // setLoading(true);
    console.log("!Login Started");
  }, []);

  const onGoogleLoginSuccess = async ({ provider, data }) => {
    console.log("provider: ", provider);
    console.log("data: ", data);
    const googleResponse = {
      name: data?.name,
      image: data?.picture,
      email_id: data?.email,
      method: "google",
    };
    handleSocialLogin(googleResponse);
  };

  const onFacebookLoginSuccess = async ({ provider, data }) => {
    const facebookResponse = {
      name: data?.name,
      image: data?.picture?.data?.url,
      email_id: data?.email,
      method: "facebook",
    };
    console.log("provider: ", provider);
    console.log("data: ", data);
    handleSocialLogin(facebookResponse);
  };

  const onMicrosoftLoginSuccess = async ({ provider, data }) => {
    console.log("provider: ", provider);
    console.log("data: ", data);
    handleSocialLogin(data);
  };

  const onLoginReject = () => (err) => {
    console.log(err);
    setError(err?.message);
    setLoading(false);
  };

  const handleSocialLogin = async (payload) => {
    console.log(payload);
    // return;
    setLoading(true);
    try {
      const response = await apiClient.post("/auth/social-login", payload);

      // dispatch(
      //   setUserDetails({
      //     id: response?.data?._id,
      //     company_id: response?.data?.company_id,
      //     name: response?.data?.name,
      //     email: response?.data?.email_id,
      //     phone_number: response?.data?.phone_number,
      //     image: response?.data?.image,
      //     role: response?.data?.user_type,
      //     company_domain: response?.data?.company_details?.domain,
      //   })
      // );

      // navigate("/");

      handleSocialLoginResponse({
        user: response?.data,
      });
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  //   const onLogoutSuccess = useCallback(() => {
  //     setProfile(null);z
  //     setProvider("");
  //     alert("logout success");
  //   }, []);

  //   const onLogout = useCallback(() => {}, []);

  return (
    <>
      {error && <div className="text-danger">{error}</div>}
      {loading && <FullPageLoader text="Loading" />}

      <LoginSocialGoogle
        client_id={process.env.REACT_APP_GOOGLE_CLIENT_ID || ""}
        onLoginStart={onLoginStart}
        scope="openid profile email"
        onResolve={onGoogleLoginSuccess}
        onReject={onLoginReject}
      >
        <GoogleLoginButton
          align={"center"}
          style={{
            borderRadius: "5px",
            lineHeight: "1.5",
            fontSize: "1rem",
            width: "100%",
            padding: "0.575rem 0.75rem",
            margin: "1rem 0rem",
            height: "inherit",
            transition:
              "color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out",
          }}
          iconSize={"1.4rem"}
        />
      </LoginSocialGoogle>

      <LoginSocialFacebook
        appId={"1136743224557142"}
        fieldsProfile={
          "id,first_name,last_name,middle_name,name,name_format,picture,short_name,email"
        }
        onLoginStart={onLoginStart}
        // onLogoutSuccess={onLogoutSuccess}
        redirect_uri={"REDIRECT_URI"}
        onResolve={onFacebookLoginSuccess}
        onReject={onLoginReject}
      >
        <FacebookLoginButton
          align={"center"}
          style={{
            borderRadius: "5px",
            fontSize: "1rem",
            width: "100%",
            padding: "0.575rem 0.75rem",
            margin: "1rem 0rem",
            height: "inherit",
            transition:
              "color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out",
          }}
          iconSize={"1.4rem"}
        />
      </LoginSocialFacebook>

      {/* <LoginSocialMicrosoft
        client_id={process.env.REACT_APP_MICROSOFT_APP_ID || "83684909-774e-45db-8f05-1ffd9f1ad655"}
        redirect_uri={"http://localhost:3000/account"}
        onLoginStart={onLoginStart}
        onResolve={onMicrosoftLoginSuccess}
        onReject={onLoginReject}
      >
        <MicrosoftLoginButton
          align={"center"}
          style={{
            borderRadius: "5px",
            fontSize: "1rem",
            width: "100%",
            padding: "0.575rem 0.75rem",
            margin: "1rem 0rem",
            height: "inherit",
            transition:
              "color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out",
          }}
          iconSize={"1.4rem"}
        />
      </LoginSocialMicrosoft> */}
    </>
  );
};

export default SocialLogin;
